<template>
  <div ref="container-raw-uid" class="container-raw-inline-interactive-item" :class="format">
    <div ref="wrapper-graph" class="graph-mujeres">
      <div class="barchart">
        <div class="casitas"><img src="https://static.univision.com/especiales/noticias/infografias/2021/evictions/raws/casitas.png"></div>

        <div class="title">Alquileres retrasados</div>
        
        <div class="entradilla">En una encuesta del Censo realizada entre el 29 de septiembre y el 11 de octubre, cerca de <span>5 de cada 10 inquilinas negras y 4 de cada 10 latinas</span> reportaron que sus hogares estaban retrasados en el pago del alquiler, en comparación con <span>1 de cada 10 hombres blancos</span>.</div>

        <div class="desc">Proporción que no está al día:</div>
        <div class="bar active"></div>
        <div class="fuente">Fuente: análisis del National Women’s Law Center en base al Pulso de Hogares del Censo. Los encuestados autoidentificaron su género y raza. En el gráfico, los hispanos no están incluidos en las categorías de raza.
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .graph-mujeres {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    padding: 20px 10px;
    font: 15px sans-serif;
    background: url("https://static.univision.com/especiales/noticias/infografias/2021/evictions/raws/background.png");

      
    .casitas {
        width: 100px;
    }

    .casitas img {
        width: 100%;
    }
    .label {
        color: #fff;
        font-size: 19px;
        font-family: Roboto Condensed, sans-serif;
        font-weight: 300;
    }

    .cat {
        margin: 15px 0;
    }
    .bar {
        max-width: 720px;
        margin: 0 auto;
    }

    .barra {
        width: 100%;
        height: 40px;
    }

    .fill {
        position: relative;
        width: 0;
        height: 40px;
        transition: width .5s;
    }

    .cifra {
        position: absolute;
        right: 10px;
        top: 8px;
        font-size: 24px;
        font-family: Roboto Condensed, sans-serif;
        color: #222222;
        opacity: 0;
        transition: opacity 2s;
    }

    .barchart {
        color: #FFD26E;
        max-width: 800px;
        margin: 0 auto;
    }
    .barchart .title {
        font-size: 36px;
        font-weight: 600;
        font-family: Roboto Condensed, sans-serif;
    }

    .barchart .entradilla {
        color: #ffffff;
        margin: 5px 0;
        font-size: 18px;
        line-height: 26px;
    }

    .barchart .entradilla span {
        color: #FFCC66;
    }

    .barchart .desc {
        max-width: 720px;
        font-family: Roboto Condensed, sans-serif;
        font-weight: 300;
        font-size: 19px;
        margin: 25px auto 0;
        color: #ffffff;
    }

    .barchart .fuente {
        color: #ffffff;
        font-size: 12px;
        font-weight: 300;
        margin-top: 30px;
    }
  }

  .container-raw-inline-interactive-item {
    width: 100%;
    min-height: 100vh !important;
  }
</style>

<script>

  export default {
    name: 'RawInteractive',
    props: {
      src: {
        type: String,
        default: ``
      }
    },
    data() {
      return {
        raw: ``,
        data: [{'lab':'Mujeres negras','val':27},{'lab':'Mujeres latinas','val':21},{'lab':'Mujeres blancas','val':14},{'lab':'Mujeres asiáticas','val':8},{'lab':'Hombres blancos','val':9}]
      }
    },
    computed: {
      url() {
        const url=this.src.split(';')
        if(url[0]){
          return url[0]
        }
        return this.src
      },
      format() {
        const url=this.src.split(';')
        if(url[1]){
          return url[1]
        }
        return ``
      }
    },
    mounted() {
      this.renderChart(this.$refs['wrapper-graph'])
      window.addEventListener('scroll',() => {
        console.log('scroll')
        this.scrollActive()
      })
    },
    methods: {
      scrollActive() {
        if(this.$refs['container-raw-uid']) {
          const top = this.$refs['container-raw-uid'].offsetTop
          if(window.scrollY >= (top - 350)) {
            this.movebars(this.$refs['wrapper-graph'])
          }
        }
      },
      movebars(wrapper) {
        let barwidth = wrapper.querySelector(".bar").offsetWidth;
        let chart = wrapper.querySelector(".bar")

        if (chart.classList[1] == 'active') {
          let abar = wrapper.querySelectorAll(".fill");
          for(let i=0;i<abar.length;i++) {
              let wi = abar[i].dataset.width;
              abar[i].style.width = ((wi*barwidth)/30)+"px";
          }

          let acif = wrapper.querySelectorAll(".cifra");
          for(let i=0;i<acif.length;i++) {
              acif[i].style.opacity = 1;
          }

        } else {
          let abar = wrapper.querySelectorAll(".fill");
          for(let i=0;i<abar.length;i++) {
              //let wi = abar[i].dataset.width;
              abar[i].style.width = 0;
          }

          let acif = wrapper.querySelectorAll(".cifra");
          for(let i=0;i<acif.length;i++) {
              acif[i].style.opacity = 0;
          }
        }

      },
      renderChart(wrapper) {

        let main = wrapper.querySelector(".bar")

        this.data.forEach(function(d){ 
            let fdiv = document.createElement("div")
            fdiv.classList.add("cat")

            let lab = document.createElement("div")
            lab.classList.add("label")
            fdiv.appendChild(lab)
            lab.innerHTML = d.lab

            let bar = document.createElement("div")
            bar.classList.add("barra")
            fdiv.appendChild(bar)

            let fill = document.createElement("div")
            fill.classList.add("fill")
            fill.style.background = "#FED26F"
            bar.appendChild(fill)
            fill.dataset.width = d.val
            fill.style.width = 0

            let cif = document.createElement("div")
            cif.classList.add("cifra")
            cif.innerHTML = d.val+"%"
            fill.appendChild(cif)

            main.appendChild(fdiv)
        })

      }
    }
  }
</script>